import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { buildDrillDownHref } from "./managementDashboardUtils";

const severityColor = {
  Critical: "error",
  Warning: "warning",
  Info: "info",
  3: "error",
  2: "warning",
  1: "info",
};

export const ManagementWidgetShell = ({
  title,
  subheader,
  loading,
  error,
  onRetry,
  children,
}) => (
  <Card sx={{ mb: 2 }}>
    <CardHeader
      title={title}
      subheader={subheader}
      action={
        onRetry ? (
          <Button size="small" startIcon={<RefreshIcon />} onClick={onRetry}>
            تلاش مجدد
          </Button>
        ) : null
      }
    />
    <CardContent>
      {loading ? (
        <Stack spacing={1}>
          <Skeleton height={48} />
          <Skeleton height={48} />
        </Stack>
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        children
      )}
    </CardContent>
  </Card>
);

export const DrillDownChip = ({ drillDown, label, count }) => {
  const href = buildDrillDownHref(drillDown);
  if (!href) {
    return <Chip label={`${label}: ${count ?? 0}`} />;
  }
  return (
    <Chip
      component={RouterLink}
      to={href}
      clickable
      color="primary"
      variant="outlined"
      label={`${label}: ${count ?? 0}`}
    />
  );
};

export const StepPipelineList = ({ steps = [] }) => (
  <Stack spacing={1}>
    {steps.map((step) => {
      const code = step.stepCode || step.StepCode;
      const title = step.persianTitle || step.PersianTitle || code;
      const current = step.currentAtStepCount ?? step.CurrentAtStepCount ?? 0;
      const completed = step.completedStepCount ?? step.CompletedStepCount ?? 0;
      const overdue = step.overdueCount ?? step.OverdueCount ?? 0;
      const drillDown = step.drillDown || step.DrillDown;
      return (
        <Box
          key={code}
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            alignItems: "center",
            justifyContent: "space-between",
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            p: 1,
          }}
        >
          <Typography variant="body2" fontWeight={600}>
            {step.sequence || step.Sequence}. {title}
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            <Chip size="small" label={`جاری: ${current}`} />
            <Chip size="small" color="success" label={`تکمیل: ${completed}`} />
            {overdue > 0 ? (
              <Chip size="small" color="error" label={`معطل: ${overdue}`} />
            ) : null}
            <DrillDownChip drillDown={drillDown} label="مشاهده" count={current || completed} />
          </Stack>
        </Box>
      );
    })}
  </Stack>
);

export const severityLabel = (severity) => {
  const map = { Critical: "بحرانی", Warning: "هشدار", Info: "اطلاع", 3: "بحرانی", 2: "هشدار", 1: "اطلاع" };
  return map[severity] || "اطلاع";
};

export const severityChipColor = (severity) => severityColor[severity] || "default";
